import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import { Ambassadors } from './index';
import '~/styles/main.scss';

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;

global.Ambassadors = Ambassadors;
// CLR alias: PortableComponent.cshtml renders AmbassadorSection blocks via this component.
global.AmbassadorSection = Ambassadors;
